import { useTheme } from '@/contexts/ThemeContext';
import LazyVideo from '@/components/LazyVideo';

const LatestWorkSection = () => {
  const { theme } = useTheme();
  const tagBgColor = theme === 'dark' ? '#FFFFFF' : '#111111';
  const tagTextColor = theme === 'dark' ? '#111111' : '#FFFFFF';

  const workItems = [
    // Left column
    {
      id: 2,
      type: 'video',
      src: 'https://kpaixcycljzsxxriyzjh.supabase.co/storage/v1/object/public/video-content/Highlight%20Reel%20-%20Lotus.mp4',
      title: 'Lotus Weight Loss',
      subtitle: 'From Zero to $2.5M Revenue in 6 Months, 10x RoAS.',
      description: 'Starting from scratch, we provided an end-to-end service encompassing website development, store setup, paid social media marketing, and content & creative development. This comprehensive strategy was instrumental in helping the client Lotus scale from a standing start to over $2.5M in revenue within their first six months of operation, achieving an impressive 10x Return on Ad Spend (RoAS).',
      services: ['Web', 'Paid Social', 'Creative', 'Content', 'Email', 'Automation'],
      size: 'rectangle'
    },
    {
      id: 1,
      type: 'video',
      src: 'https://kpaixcycljzsxxriyzjh.supabase.co/storage/v1/object/public/video-content/TXIAA%20(1).mp4',
      title: 'Widgetly.AI',
      subtitle: 'AI-Powered Web Build: Innovation in Website Widgets',
      description: 'We built an innovative platform for AI-powered website widgets, leveraging the OpenAI API and knowledge base training. It includes a secure user dashboard with SSO and a Stripe integration for payments, bringing commercial readiness to AI tools.',
      services: ['Web', 'AI', 'Automation'],
      size: 'square'
    },
    {
      id: 3,
      type: 'video',
      src: 'https://kpaixcycljzsxxriyzjh.supabase.co/storage/v1/object/public/video-content/Brown%20Simple%20Marketing%20Planner%20Product%20Mockup%20Instagram%20Post.mp4',
      title: 'The Fiduciary Firm',
      subtitle: 'Driving 500% ROI with Full-Funnel Automation',
      description: 'We delivered a complete strategy, focusing on branding, website, funnels, and lead generation. This included developing e-books, calculators, and email workflow automation with live chat, ultimately driving a massive 500% ROI for the firm.',
      services: ['Web', 'Funnels', 'Lead Magnets', 'Content', 'Google Ads', 'Paid Social', 'Email', 'Automation'],
      size: 'square'
    },
    // Right column
    {
      id: 4,
      type: 'video',
      src: 'https://kpaixcycljzsxxriyzjh.supabase.co/storage/v1/object/public/video-content/1020%20%2810%29.mp4',
      title: 'Andrew Rankin: Professional Services',
      subtitle: 'Top-Ranked Local Presence and $2M Client Win',
      description: 'Full web build & Lead Gen. Combining Google Ads, Local SEO, Enriched B2B Data and content funnels resulted in top rankings on Google and ChatGPT within 30 days, successfully securing a $2M client among other wins.',
      services: ['Web', 'Lead Gen', 'Paid Social', 'Email', 'SEO', 'AEO', 'Content', 'Lead Magnets'],
      size: 'square'
    },
    {
      id: 5,
      type: 'video',
      src: 'https://kpaixcycljzsxxriyzjh.supabase.co/storage/v1/object/public/video-content/TXIAA.mp4',
      title: 'TXIAA (Texas Insurance & Annuities)',
      subtitle: 'Covering a Year of Ad Spend in 60 Days',
      description: 'We executed a complete web build with advanced funnel automation and targeted PPC campaigns. This strategic deployment resulted in new commissions within the first 60 days of launch that completely covered the entire year\'s advertising spend.',
      services: ['Web', 'PPC', 'Funnels', 'Automation', 'Creative'],
      size: 'square'
    },
    {
      id: 6,
      type: 'video',
      src: 'https://kpaixcycljzsxxriyzjh.supabase.co/storage/v1/object/public/video-content/1020%20(6).mp4',
      title: 'Podcast Style Creative',
      subtitle: '30%+ Growth in Assets Under Management via Video Content',
      description: 'We created over 100 podcast videos used as ads and lead magnets. This, with aggressive ad spend, affirmed EEAT, increasing the advisory firm\'s assets under management by 30%+ in one year.',
      services: ['Creative', 'Editing', 'Funnels', 'Paid Ads', 'Automation'],
      size: 'rectangle'
    },
  ];

  return (
    <section className="pt-2 pb-20 md:pt-6 md:pb-12">
      <div className="max-w-3xl mx-auto px-[7%] md:px-6">
        <div className="grid grid-cols-2 gap-3">
          {/* Left Column */}
          <div className="space-y-3">
            {workItems.slice(0, 3).map((item) => (
              <div
                key={item.id}
                className={`relative group overflow-hidden rounded-lg ${
                  item.size === 'rectangle' ? 'aspect-[9/16]' : 'aspect-square'
                }`}
              >
                {item.type === 'video' ? (
                  <LazyVideo
                    src={item.src}
                    containerClassName="w-full h-full"
                  />
                ) : (
                  <img
                    src={item.src}
                    alt={item.title}
                    className="w-full h-full object-cover"
                  />
                )}
                
                {/* Hover Overlay */}
                <div className={`absolute inset-0 ${
                  (item.id === 2 || item.id === 1 || item.id === 3 || item.id === 4 || item.id === 5 || item.id === 6)
                    ? 'bg-black/80 backdrop-blur-sm' 
                    : 'bg-gradient-to-t from-black/90 via-black/50 to-transparent'
                } opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4`}>
                  <h3 className={`text-white font-bold mb-1 ${(item.id === 2 || item.id === 1 || item.id === 3 || item.id === 4 || item.id === 5 || item.id === 6) ? 'text-lg' : 'text-base'}`}>{item.title}</h3>
                  {item.subtitle && (
                    <p className={`text-white/95 font-semibold mb-2 ${(item.id === 2 || item.id === 1 || item.id === 3 || item.id === 4 || item.id === 5 || item.id === 6) ? 'text-sm' : 'text-xs'}`}>{item.subtitle}</p>
                  )}
                  <p className={`text-white/90 ${(item.id === 2 || item.id === 1 || item.id === 3 || item.id === 4 || item.id === 5 || item.id === 6) ? 'text-xs mb-3 line-clamp-4' : 'text-xs'} whitespace-pre-line`}>{item.description}</p>
                  {(item.id === 2 || item.id === 1 || item.id === 3 || item.id === 4 || item.id === 5 || item.id === 6) && item.services && (
                    <div className="flex flex-wrap gap-2">
                      {item.services.map((service: string) => (
                        <span key={service} className="px-2 py-0.5 rounded-md text-xs font-semibold" style={{ backgroundColor: tagBgColor, color: tagTextColor }}>
                          {service}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* Right Column */}
          <div className="space-y-3">
            {workItems.slice(3, 6).map((item) => (
              <div
                key={item.id}
                className={`relative group overflow-hidden rounded-lg ${
                  item.size === 'rectangle' ? 'aspect-[9/16]' : 'aspect-square'
                }`}
              >
                {item.type === 'video' ? (
                  <LazyVideo
                    src={item.src}
                    containerClassName="w-full h-full"
                  />
                ) : (
                  <img
                    src={item.src}
                    alt={item.title}
                    className="w-full h-full object-cover"
                  />
                )}
                
                {/* Hover Overlay */}
                <div className={`absolute inset-0 ${
                  (item.id === 2 || item.id === 1 || item.id === 3 || item.id === 4 || item.id === 5 || item.id === 6)
                    ? 'bg-black/80 backdrop-blur-sm' 
                    : 'bg-gradient-to-t from-black/90 via-black/50 to-transparent'
                } opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4`}>
                  <h3 className={`text-white font-bold mb-1 ${(item.id === 2 || item.id === 1 || item.id === 3 || item.id === 4 || item.id === 5 || item.id === 6) ? 'text-lg' : 'text-base'}`}>{item.title}</h3>
                  {item.subtitle && (
                    <p className={`text-white/95 font-semibold mb-2 ${(item.id === 2 || item.id === 1 || item.id === 3 || item.id === 4 || item.id === 5 || item.id === 6) ? 'text-sm' : 'text-xs'}`}>{item.subtitle}</p>
                  )}
                  <p className={`text-white/90 ${(item.id === 2 || item.id === 1 || item.id === 3 || item.id === 4 || item.id === 5 || item.id === 6) ? 'text-xs mb-3 line-clamp-4' : 'text-xs'} whitespace-pre-line`}>{item.description}</p>
                  {(item.id === 2 || item.id === 1 || item.id === 3 || item.id === 4 || item.id === 5 || item.id === 6) && item.services && (
                    <div className="flex flex-wrap gap-2">
                      {item.services.map((service: string) => (
                        <span key={service} className="px-2 py-0.5 rounded-md text-xs font-semibold" style={{ backgroundColor: tagBgColor, color: tagTextColor }}>
                          {service}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LatestWorkSection;